import React, {FC, useMemo} from "react";
import {Route, Routes} from "react-router-dom";
import Home from "./Home";
import {ConnectionProvider, WalletProvider,} from "@solana/wallet-adapter-react";
import {WalletModalProvider} from "@solana/wallet-adapter-react-ui";
import {WalletAdapterNetwork} from "@solana/wallet-adapter-base";
import {clusterApiUrl} from "@solana/web3.js";
import {PhantomWalletAdapter, SolflareWalletAdapter,} from "@solana/wallet-adapter-wallets";
import {Layout} from "./theme/layout";
import Header from "./theme/header/header";

import "nprogress/nprogress.css";
import {ThirdwebProvider} from "@thirdweb-dev/react";
import Footer from "./theme/footer/footer";


require("@solana/wallet-adapter-react-ui/styles.css");

export type Props = {};

const App: FC<Props> = (props: Props) => {
  const network = String(process.env.REACT_APP_ENV)==="development"? WalletAdapterNetwork.Devnet: WalletAdapterNetwork.Mainnet;
  console.log("network ", network)
  console.log(String(process.env.REACT_APP_ENV))
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);
  // const endpoint = "https://yolo-wandering-energy.solana-mainnet.discover.quiknode.pro/6f41ed47abb866a37142ffbcca2f6214dc664b71/";

  const wallet = useMemo(
    () => [new PhantomWalletAdapter(), new SolflareWalletAdapter({ network })],
    [network]
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallet} autoConnect>
        <WalletModalProvider>
          <ThirdwebProvider activeChain="ethereum">
          <div className="App">
            <Header />
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
              </Route>
            </Routes>
            <Footer />
          </div>
          </ThirdwebProvider>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};
export default App;
